import { styled, Box } from '@mui/material';

/**
 * Surface shared by every card on the Dashboard. Cards that cannot use
 * {@link DashboardCard} because they need their own sizing still read these,
 * so a card sitting under the stat tiles matches their edge and elevation.
 */
export const DASHBOARD_CARD_SURFACE = {
    borderRadius: '12px',
    borderColor: '#e0e0e0',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.4)'
} as const;

export const DashboardCard = styled(Box)`
    /* min-width: 365.33px; */
    height: 176px;
    border-radius: ${DASHBOARD_CARD_SURFACE.borderRadius};
    border-width: 1px;
    border-style: solid;
    overflow: hidden;
    border-color: ${DASHBOARD_CARD_SURFACE.borderColor};
    gap: 24px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: ${DASHBOARD_CARD_SURFACE.boxShadow};
`;
